import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, LinearProgress, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from "date-fns/locale/fr";
import Fetcher from '../../services/fetcher';
import settings from '../../settings';
import { useNotification } from '../../contexts/Notification';

interface PreviewProps {
  toggleModal: boolean,
  body: any,
  onQuitModal: () => void
}

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  button: {
    margin: '1vh'
  }
}));

const setDefaultDate = () => {
  const date = new Date();

  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);

  if (date.getTime() < Date.now()) {
    date.setDate(date.getDate() + 1);
  }
  return date;
};

const Generate = (props: PreviewProps) => {
  const classes = useStyles();
  const [date, setDate] = useState<Date | null>(setDefaultDate());
  const [loading, setLoading] = useState<boolean>(false);
  const notification = useNotification();

  const generateNewsletter = (takeDate: boolean) => {
    setLoading(true);
    if (date) {
      const dateToSend = date.getTime() / 1000;
      Fetcher.post(
        settings.newsletterApi + 'generate',
        JSON.stringify({data: props.body, date: takeDate ? dateToSend : 0})
      ).then((res: any) => {
        console.log(res);
        if (takeDate)
          notification.notify('Newsletter programmée pour le ' + date?.toLocaleString('fr-FR'));
        else
          notification.notify('Envoi de la newsletter en cours.');
      }).catch((err) => {
        console.error(err);
        notification.notify('Quelque chose s\'est mal passé', 'error');
      }).finally(() => {
        props.onQuitModal();
      });
    }
  };

  return (
    <Dialog open={props.toggleModal} onClose={props.onQuitModal} maxWidth="md">
      <DialogTitle>
        Programmation et génération de la newsletter
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
          <KeyboardDateTimePicker
            label="Selectionnez la date et l'heure de l'envoi du mail"
            value={date}
            onChange={setDate}
            format="dd/MM/yyyy HH:mm"
            variant="inline"
            KeyboardButtonProps={{
                'aria-label': 'change date',
            }}
            ampm={false}
            fullWidth
            inputVariant="outlined"
          />
        </MuiPickersUtilsProvider>
        <Tooltip title="Attention ! Non annulable" aria-label="add">
          <Button
            disabled={loading}
            variant="outlined"
            className={classes.button}
            onClick={() => generateNewsletter(true)}
          >Générer et envoyer</Button>
        </Tooltip>
        <Divider />
        <Tooltip title="Attention ! Non annulable" aria-label="add">
          <Button
            disabled={loading}
            variant="outlined"
            className={classes.button}
            onClick={() => generateNewsletter(false)}
          >Générer et envoyer maintenant</Button>
        </Tooltip>
        {loading && <LinearProgress />}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={props.onQuitModal}>Annuler</Button>
      </DialogActions>
    </Dialog>
  );
}

export default Generate;